import { AutoCompleteWithLabelProps } from '.';

// This object should contain a mock value for each required prop of this component
export const requiredProps: AutoCompleteWithLabelProps = {
  label: 'title',
  options: [
    { id: 0, value: 'aaa' },
    { id: 1, value: 'abb' },
    { id: 2, value: 'bbb' },
    { id: 3, value: 'bcc' },
  ],
};

// This array should contain an object only for tests you wish to run on all compliance tests
const sharedTests = [
  {
    title: 'render',
    props: {
      ...requiredProps,
    } as AutoCompleteWithLabelProps,
  },
];

export const testkitTests = [...sharedTests];

export const ssrTests = [...sharedTests];

export const a11yTests = [...sharedTests];
